import { Component, OnInit , ViewChild, TemplateRef, ElementRef, Input, Output, EventEmitter} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NgxBlocklyConfig, NgxBlocklyGeneratorConfig } from 'ngx-blockly';
import { ExampleMutator } from './../blocks/example.mutator';
import { ExampleBlock } from './../blocks/example.block';
import { NgxToolboxBuilderService, LOGIC_CATEGORY, LOOP_CATEGORY, MATH_CATEGORY, TEXT_CATEGORY, LISTS_CATEGORY, COLOUR_CATEGORY, VARIABLES_CATEGORY, FUNCTIONS_CATEGORY } from 'ngx-blockly';
import { Separator } from 'ngx-blockly';
import { NgxBlocklyComponent } from 'ngx-blockly';
import { FormulasService } from '../../../services/formulas.service';
import { AcumuladorService } from '../../../services/acumulador.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormulaDTO } from 'app/models/formula-dto';
import { i18nMetaToJSDoc } from '@angular/compiler/src/render3/view/i18n/meta';
import { DialogConfirmacionComponent } from '../../shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../shared/dialog-procesando/dialog-procesando.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErroresService } from '../../../core/services/errores.service';

declare var Blockly: any;

@Component({
  selector: 'app-blockly-edit',
  templateUrl: './blockly-edit.component.html',
  styleUrls: ['./blockly-edit.component.css']
})
export class BlocklyEditComponent implements OnInit {

  @Input() formulaActual: any;
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarLista = new EventEmitter<''>();

  formulas:any;
  modalRef: BsModalRef;
  codigo: any;
  xml: any;
  toolbox: any;
  MensajeError: string = '';
  formulaInvalida: boolean;
  guardandoFormula: boolean;
  mensajeExitoGuardado: string;
  esNuevo: boolean = true;
  esCopia: boolean = false;
  inputDescripcion: string = '';
  public variables: any = null;
  

  public constructor(ngxToolboxBuilder: NgxToolboxBuilderService, 
                    private formulasService: FormulasService,
                    private modalService: BsModalService,
                    private dialog: MatDialog,
                    private snackBar: MatSnackBar,
                    private erroresService: ErroresService) {
  }

  openModal(template: TemplateRef<any>) {
    this.formulaInvalida = false;
    this.modalRef = this.modalService.show(template);
  }

  ngOnInit() {
    this.retrieveVariables();
    this.cargarToolbox(); 
    
    if (this.formulaActual.id == undefined)
    {
      this.nuevaFormula();
    } else
    {
      this.inputDescripcion = this.formulaActual.descripcion;
      this.cargarFormula(this.formulaActual);
    }
  }

  @ViewChild(NgxBlocklyComponent,{static: true}) workspace: any;
  

  public customBlocks = [
      //new ExampleBlock(null, new ExampleMutator('example_mutator'))
  ];
  
  //https://github.com/google/blockly-samples/blob/master/examples/custom-toolbox-codelab/complete-code/index.html
  

  public config:
    NgxBlocklyConfig = {
    toolbox: '<xml id="toolbox" style="display: none"></xml>',
    horizontalLayout: false,
    comments: true,
    scrollbars: true,
    trashcan: true,
      search: {
      placeholder: 'Buscar',
      enabled: true
    },
    zoom:
      {
      controls: true,
      wheel: true,
      startScale: 1.0,
      maxScale: 2,
      minScale: 0.5,
      scaleSpeed: 1.2
      }
    };

  public generatorConfig: NgxBlocklyGeneratorConfig = {
    //javascript: true,
    xml: true    
  };

  cancelar(): void
  {
    this.VisualizarLista.emit();
  }

  save(id, codigo, descripcion) {
    this.codigo = Blockly.CSharp.workspaceToCode(this.workspace.workspace);
    this.xml = this.workspace.toXml();
    let data = new FormulaDTO();
    data.Id = id;
    data.CShapValue = this.codigo;
    data.XMLValue = this.xml;
    data.FormulaType = 'Unica';
    data.Codigo = codigo;
    data.Descripcion = descripcion;
    data.StringValue = ' ';
    data.StringFormat = ' ';

    this.saveFormula(data)
  };

  toCode  (template: TemplateRef<any>) {
    if (this.esNuevo){
      this.codigo = Blockly.CSharp.workspaceToCode(this.workspace.workspace);
      this.xml = this.workspace.toXml();
      console.log(this.codigo);  
      console.log(this.xml);
      this.openModal(template);
    }else{

      this.save(this.formulaActual.id, this.formulaActual.codigo,this.inputDescripcion);
    }
    
  };

  toCopy  (template: TemplateRef<any>) {
    this.esCopia = true;
    this.codigo = Blockly.CSharp.workspaceToCode(this.workspace.workspace);
    this.xml = this.workspace.toXml();
    console.log(this.codigo);  
    console.log(this.xml);
    this.openModal(template);
  };

  retrieveVariables(): void {
    this.formulasService.getVariables()
      .subscribe(
        data => {
          this.formulas = data;
          var xmlList = [];
          let categoria = 0;
          let categoriaAnt = 0;
          let category = null;
          let tabla = null;
          data.forEach(element => {
            var toolbox = '<block type="variables_get"><field name="VAR">'+ element +'</field></block>';
            var newBlock = {
              blockxml: toolbox,
              kind: "BLOCK",
              type: "variables_get"
            };
            tabla = element.substr(0, element.indexOf('.'));
            if (tabla==''){
              tabla = element.substr(0, element.indexOf('['));
            } 
            switch(tabla) { 
              case 'AuxConceptos': { 
                categoria = 1;
                break; 
              } 
              case 'AuxFecha': { 
                categoria = 2;
                break; 
              } 
              case 'AuxHijos': { 
                categoria = 3;
                break; 
              } 
              case 'AuxHorario': { 
                categoria = 4;
                break; 
              } 
              case 'AuxAfiliaciones': { 
                categoria = 5;
                break; 
              } 
              case 'AuxAcumuladores': { 
                categoria = 6;
                break; 
              } 
              case 'AuxBases': { 
                categoria = 7;
                break; 
              } 
              case 'AuxConstantes': { 
                categoria = 8;
                break; 
              } 
              case 'AuxPromedios': { 
                categoria = 9;
                break; 
              } 
              case 'AuxDatosMaestros': { 
                categoria = 10;
                break; 
              } 
              case 'Liquidacion': { 
                categoria = 11;
                break; 
              } 
              default: { 
                categoria = 12;
                break; 
              } 
            }; 
            if (categoria != categoriaAnt){
              if (categoriaAnt!=0){
                category = Blockly.getMainWorkspace().getToolbox().getToolboxItems()[categoriaAnt];
                category.updateFlyoutContents(xmlList);
              }
              categoriaAnt = categoria;
              xmlList = [];
            }
            xmlList.push(newBlock);
            
          });
          category = Blockly.getMainWorkspace().getToolbox().getToolboxItems()[categoriaAnt];
          category.updateFlyoutContents(xmlList);
        },
        error => {
          console.log(error);
        });
  }

  cargarFormula(formula): void {
    this.esNuevo = false;
    this.formulasService.getFormulasById(formula.id)
      .subscribe(
        data => {
          this.workspace.fromXml(data.xmlvalue);
        },
        error => {
          console.log(error);
        });
  }

  nuevaFormula(): void {
    this.esNuevo = true;
    this.workspace.clear();
  }

  cargarToolbox(): void{
    this.toolbox = '<xml id="toolbox" style="display: none">' +
        '<category name="Funciones Lógicas" colour="210">' +
          '<block type="controls_if" ></block>' +
          '<block type="controls_repeat_ext"></block>' +
          '<block type="controls_whileUntil"></block>' +
          '<block type="logic_compare"></block>' +
          '<block type="logic_operation"></block>'+
          '<block type="math_number"></block>' +
          '<block type="logic_boolean"></block>'+
          '<block type="math_arithmetic"></block>' +
          '<block type="text"></block>' +
          '<block type="logic_null"></block>' +
        '</category>' +
        '<category name="Conceptos" colour="50"></category>' +
        '<category name="Fecha" colour="180"></category>' +
        '<category name="Hijos" colour="220"></category>' +
        '<category name="Horario" colour="260"></category>' +
        '<category name="Afiliaciones" colour="300"></category>' +
        '<category name="Acumuladores" colour="340"></category>'+
        '<category name="Bases" colour="380"></category>' +
        '<category name="Constantes" colour="420"></category>' +
        '<category name="Promedios" colour="460"></category>' +
        '<category name="Datos Maestros" colour="500"></category>' +
        '<category name="Liquidación" colour="540"></category>' +
        '<category name="Fórmulas" colour="20"></category>' +
        '<category name="Variables" categorystyle="variable_category" custom="VARIABLE"></category>'+
        '<category name="Funciones" categorystyle="procedure_category" custom="PROCEDURE"></category>';
      
        this.toolbox += '</xml>';
        this.config.toolbox = this.toolbox;
  }

  saveFormula(data): void {
    this.guardandoFormula = true;
    let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
      width: '400px'
    });
    dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";
    
    this.formulasService.saveFormula(data).subscribe(
      data => 
      {
        setTimeout(function ()
        {
          this.guardandoFormula = false;
          dialogProcesandoRef.close();
        });
        
        this.mensajeExitoGuardado = "Fórmula guardada";
        this.snackBar.open(this.mensajeExitoGuardado, "OK", { duration: 10000 });
        
        if (this.esCopia || this.esNuevo) this.modalRef.hide();

        this.cancelar();
      },
      error => 
      {
        this.guardandoFormula = false;
        dialogProcesandoRef.close();
        if (error.status == 400)
        {
          this.formulaInvalida = true;

          this.MensajeError = this.erroresService.MostrarError400(error);
        }
        else
        {
          this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
        }
        console.log(error);
      });
      
  }

  //Para regenerar csharp npm run build:generators
  //https://developers.google.com/blockly/guides/modify/web/building

  //http://ranux.github.io/blockly-editor/
  //https://stackoverflow.com/questions/52921698/how-do-we-import-blockly-into-an-angular-7-application
  //Blockly.JavaScript.workspaceToCode();
  /*
  blocklyArea: document.getElementById('blocklyArea');
  blocklyDiv: document.getElementById('blocklyDiv');
  workspace: Blockly.inject(blocklyDiv, {toolbox: document.getElementById('toolbox')});
  onresize: function(e) {
      // Compute the absolute coordinates and dimensions of blocklyArea.
      var element = blocklyArea;
      var x = 0;
      var y = 0;
      do {
        x += element.offsetLeft;
        y += element.offsetTop;
        element = element.offsetParent;
      } while (element);
      // Position blocklyDiv over blocklyArea.
      blocklyDiv.style.left = x + 'px';
      blocklyDiv.style.top = y + 'px';
      blocklyDiv.style.width = blocklyArea.offsetWidth + 'px';
      blocklyDiv.style.height = blocklyArea.offsetHeight + 'px';
      Blockly.svgResize(workspace);
    };

    //window.addEventListener('resize', onresize, false);
    @HostListener('window:resize', ['$event'])
    onResize(event) {
      // do something meaningful with it
      event.target.innerWidth;
      console.log(`The user just pressed ${ev.key}!`);
    }
      
    onresize();

    Blockly.svgResize(workspace);
  */

}